import React from "react";
import PropTypes from "prop-types";
import {FaRegularIcon, FaSolidIcon} from "../../../components/FontAwesomeIcons";

export class CreateEventDetailsStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coverPreviewUrl: null,
            coordinatesOpen: false,
        };
        this.coverImageStyle = {
            height: "160px",
            objectFit: "cover",
        };
        this.coverPickerStyle = {
            cursor: "pointer",
        };
    }

    componentWillUnmount() {
        this.revokeCoverPreviewUrl();
    }

    revokeCoverPreviewUrl = _ => {
        if (this.state.coverPreviewUrl) {
            URL.revokeObjectURL(this.state.coverPreviewUrl);
        }
    }

    handleCoverChange = e => {
        const file = e.target.files && e.target.files[0];
        if (!file) {
            return;
        }
        this.revokeCoverPreviewUrl();
        this.setState({coverPreviewUrl: URL.createObjectURL(file)});
        this.props.onDataChange("cover")(file);
        e.target.value = null;
    }

    toggleCoordinates = _ => this.setState({coordinatesOpen: !this.state.coordinatesOpen})

    isEndDateInvalid = _ => this.props.eventData.startDate &&
        this.props.eventData.endDate &&
        this.props.eventData.endDate <= this.props.eventData.startDate

    isStartDateBeforeToday = _ => this.props.eventData.startDate &&
        this.props.eventData.startDate.substring(0, 10) < this.props.minEventDate

    render() {
        return (
            <div className={"container"}>
                <div className={"my-3"}>
                    <h5 className={"font-weight-bold mb-1"}>Crea il tuo evento</h5>
                    <div className={"text-muted"}>Aggiungi informazioni principali</div>
                </div>

                <div className={"form-group mt-2"}>
                    <div className={"font-weight-bold"}>
                        <span className={"text-magenta mr-1"}>
                            <FaSolidIcon name={"camera"}/>
                        </span>
                        Foto copertina
                    </div>
                    <label
                        className={"rounded shadow-sm mb-0 overflow-hidden bg-light w-100 d-block"}
                        style={this.coverPickerStyle}
                    >
                        {
                            this.state.coverPreviewUrl ?
                                <img
                                    src={this.state.coverPreviewUrl}
                                    className={"w-100 d-block"}
                                    style={this.coverImageStyle}
                                    alt={"Anteprima copertina evento"}
                                /> :
                                <div
                                    className={"d-flex flex-column align-items-center justify-content-center text-muted"}
                                    style={this.coverImageStyle}
                                >
                                    <FaSolidIcon name={"image"} className={"mb-2"}/>
                                    <span className={"small font-weight-bold"}>Carica la foto copertina dell'evento</span>
                                </div>
                        }
                        <input
                            type={"file"}
                            accept={"image/*"}
                            className={"d-none"}
                            onChange={this.handleCoverChange}
                        />
                    </label>
                </div>

                <div className={"form-group"}>
                    <div className={"font-weight-bold"}>
                        <span className={"text-magenta mr-1"}>
                            <FaSolidIcon name={"font"}/>
                        </span>
                        Nome evento *
                    </div>
                    <input
                        type={"text"}
                        className={"form-control"}
                        value={this.props.eventData.name}
                        onChange={this.props.onInputChange("name")}
                    />
                </div>

                <div className={"form-row"}>
                    <div className={"form-group col-6 "}>
                        <div className={"font-weight-bold"}>
                            <span className={"text-magenta mr-1"}>
                                <FaRegularIcon name={"calendar"}/>
                            </span>
                            Inizio evento *
                        </div>
                        <input
                            type={"datetime-local"}
                            className={`form-control ${this.isStartDateBeforeToday() ? "is-invalid" : ""}`}
                            value={this.props.eventData.startDate}
                            onChange={this.props.onInputChange("startDate")}
                            min={`${this.props.minEventDate}T00:00`}
                            required
                        />
                        {
                            this.isStartDateBeforeToday() &&
                            <div className={"invalid-feedback d-block"}>
                                La data dell'evento non può essere precedente a oggi.
                            </div>
                        }
                    </div>
                    <div className={"form-group col-6"}>
                        <div className={"font-weight-bold"}>
                            Fine evento *
                        </div>
                        <input
                            type={"datetime-local"}
                            className={`form-control ${this.isEndDateInvalid() ? "is-invalid" : ""}`}
                            value={this.props.eventData.endDate}
                            onChange={this.props.onInputChange("endDate")}
                            min={this.props.eventData.startDate}
                            required
                        />
                        {
                            this.isEndDateInvalid() &&
                            <div className={"invalid-feedback d-block"}>
                                La fine evento deve essere successiva all'inizio.
                            </div>
                        }
                    </div>
                </div>

                <div className={"card card-body border-0 shadow-sm p-3 my-2"}>
                    <div className={"mb-3"}>
                        <div className={"font-weight-bold"}>
                            <span className={"text-magenta mr-1"}>
                                <FaSolidIcon name={"map-pin"}/>
                            </span>
                            Luogo
                        </div>
                        <div>
                            <small className={"text-muted"}>
                                Inserisci le informazioni per raggiungere il luogo dell'evento
                            </small>
                        </div>
                    </div>

                    <div className={"form-group"}>
                        <label>Nome luogo</label>
                        <input
                            type={"text"}
                            className={"form-control"}
                            value={this.props.eventData.placeName}
                            onChange={this.props.onInputChange("placeName")}
                            placeholder={"Casa di Marco, Sala compleanni, Giardino..."}
                        />
                    </div>

                    <div className={"form-group"}>
                        <label>Indirizzo</label>
                        <input
                            type={"text"}
                            className={"form-control"}
                            value={this.props.eventData.address}
                            onChange={this.props.onInputChange("address")}
                            placeholder={"Via, numero civico, città"}
                        />
                    </div>

                    <div className={"form-group"}>
                        <label>Indicazioni per raggiungere il luogo</label>
                        <textarea
                            className={"form-control"}
                            rows={3}
                            value={this.props.eventData.directions}
                            onChange={this.props.onInputChange("directions")}
                            placeholder={"Scala, interno, parcheggio, citofono o altre indicazioni utili"}
                        />
                    </div>

                    <button
                        type={"button"}
                        className={"btn btn-link text-primary font-weight-bold p-0"}
                        onClick={this.toggleCoordinates}
                    >
                        Inserisci coordinate <FaSolidIcon name={this.state.coordinatesOpen ? "chevron-down" : "chevron-right"} className={"ml-1"}/>
                    </button>

                    {
                        this.state.coordinatesOpen &&
                        <div className={"form-row mt-3"}>
                            <div className={"form-group col-12 col-md-6"}>
                                <label>Latitudine</label>
                                <input
                                    type={"number"}
                                    step={"any"}
                                    className={"form-control"}
                                    value={this.props.eventData.latitude}
                                    onChange={this.props.onInputChange("latitude")}
                                />
                            </div>
                            <div className={"form-group col-12 col-md-6"}>
                                <label>Longitudine</label>
                                <input
                                    type={"number"}
                                    step={"any"}
                                    className={"form-control"}
                                    value={this.props.eventData.longitude}
                                    onChange={this.props.onInputChange("longitude")}
                                />
                            </div>
                        </div>
                    }
                </div>

                <div className={"form-group"}>
                    <div className={"font-weight-bold"}>
                        <span className={"text-magenta mr-1"}>
                            <FaRegularIcon name={"file"}/>
                        </span>
                        Descrizione
                    </div>
                    <textarea
                        className={"form-control"}
                        rows={4}
                        value={this.props.eventData.description}
                        onChange={this.props.onInputChange("description")}
                    />
                </div>
                <div className={"mb-5 pb-4"}/>
            </div>
        );
    }
}

CreateEventDetailsStep.propTypes = {
    eventData: PropTypes.object,
    onInputChange: PropTypes.func,
    onDataChange: PropTypes.func,
    minEventDate: PropTypes.string,
};
